"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableByRange = exports.DateField = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var useStyles_1 = require("../../styles/hooks/useStyles");
var react_2 = require("../../util/react");
var Calendar_1 = require("../Calendar");
var util_1 = require("../Calendar/util");
var FocusManagerContainer_1 = require("../FocusManagerContainer");
var DateInput_1 = require("./DateInput");
function DateField(props) {
    var calendarProps = props.calendarProps, popperProps = props.popperProps, minDate = props.minDate, maxDate = props.maxDate, value = props.value, onClick = props.onClick, icon = props.icon, onIconClick = props.onIconClick, rest = __rest(props, ["calendarProps", "popperProps", "minDate", "maxDate", "value", "onClick", "icon", "onIconClick"]);
    var _a = useStyles_1.useStyles(createStyles), css = _a.css, classes = _a.classes;
    var _b = react_1.useState(), inputRef = _b[0], setInputRef = _b[1];
    var _c = react_1.useState(), popupRef = _c[0], setPopupRef = _c[1];
    var _d = react_1.useState(false), open = _d[0], setOpen = _d[1];
    var _e = react_1.useState(new Date()), visibleDate = _e[0], setVisibleDate = _e[1];
    react_1.useEffect(function () {
        setVisibleDate(util_1.isValidDate(value) ? value : new Date());
    }, [value]);
    var _f = react_popper_1.usePopper(inputRef, popupRef, __assign(__assign({}, popperProps), { placement: 'bottom-start' })), popperStyle = _f.styles.popper, placement = _f.attributes.placement;
    var handleDayClick = function (day) {
        inputRef.focus();
        setOpen(false);
        return props.onChange(day);
    };
    var handleIconClick = function () { return setOpen(true); };
    var handleInputIconClick = function () { return setOpen(true); };
    var handleFocusIn = function () { return setOpen(true); };
    var handleFocusOut = function () { return setOpen(false); };
    var handleVisibleDateChange = function (newVisibleDate) { return setVisibleDate(newVisibleDate); };
    return (react_1.default.createElement(FocusManagerContainer_1.FocusManagerContainer, { onFocusIn: handleFocusIn, onFocusOut: handleFocusOut },
        react_1.default.createElement(DateInput_1.DateInput, __assign({ inputRef: setInputRef, value: value, icon: icon, onIconClick: react_2.composeHandlers(handleInputIconClick, onIconClick), onClick: react_2.composeHandlers(handleIconClick, onClick) }, rest)),
        open && (react_1.default.createElement("div", { ref: setPopupRef, className: css(classes.root, popperStyle), "data-placement": placement, tabIndex: -1 },
            react_1.default.createElement(Calendar_1.Calendar, __assign({ visibleDate: visibleDate, onVisibleDateChange: handleVisibleDateChange, onDayClick: handleDayClick, modifiers: {
                    selected: function (day) { return value && util_1.isSameDay(day, value); },
                    disabled: exports.disableByRange(props.minDate, props.maxDate),
                } }, calendarProps))))));
}
exports.DateField = DateField;
DateField.defaultProps = {
    icon: 'calendarOutline',
    onChange: function () { return null; },
    onFocus: function () { return null; },
    onClick: function () { return null; },
    transformTwoYearDigit: false,
};
exports.disableByRange = function (minDate, maxDate) {
    var realMinDate = new Date(minDate);
    realMinDate.setHours(0, 0, 0, 0);
    var realMaxDate = new Date(maxDate);
    realMaxDate.setHours(23, 59, 59, 999);
    return function (day) {
        return (minDate && day < realMinDate) || (maxDate && day > realMaxDate);
    };
};
var createStyles = function (theme) { return ({
    root: {
        zIndex: theme.zIndex.popper,
        background: theme.pallete.surface.main,
        boxShadow: theme.shadows.outer[40],
        borderRadius: theme.radius.popper,
        padding: '0.5rem .25rem .25rem .25rem',
        outline: 'none',
    },
}); };
//# sourceMappingURL=DateField.js.map